import React, { useRef, useState } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { accionesDocumento } from '../../utils/accionesDocumento';
import api from '../../utils/api';

export default function DocumentoEliminar({ tipo, documento, onEliminado }) {
  const { usuario, empresa } = useAuth();
  const [error, setError] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const ocupadoRef = useRef(false);
  const eliminar = async () => {
    if (ocupadoRef.current || !accionesDocumento(usuario, empresa, tipo, documento).eliminar) return;
    if (!window.confirm('¿Eliminar este documento?') || !accionesDocumento(usuario, empresa, tipo, documento).eliminar) return;
    ocupadoRef.current = true;
    setOcupado(true);
    setError(null);
    try {
      await api.delete(`/${tipo}/${documento._id}`);
      await onEliminado?.();
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo eliminar el documento');
    } finally {
      ocupadoRef.current = false;
      setOcupado(false);
    }
  };
  if (!accionesDocumento(usuario, empresa, tipo, documento).eliminar) return null;
  return <>
    <button type="button" className="btn danger" title="Eliminar" disabled={ocupado} onClick={eliminar}><FiTrash2 /> Eliminar</button>
    {error && <span className="alert-error" role="alert">{error}</span>}
  </>;
}